var map = {
	"./afternoonTea/0.png": 8189,
	"./afternoonTea/1.png": 8748,
	"./afternoonTea/2.png": 3925,
	"./afternoonTea/3.png": 2950,
	"./afternoonTea/4.png": 7445,
	"./afternoonTea/5.png": 8959,
	"./afternoonTea/6.png": 6842,
	"./birthday/0.png": 539,
	"./birthday/1.png": 2601,
	"./birthday/2.png": 671,
	"./birthday/3.png": 1818,
	"./birthday/4.png": 9961,
	"./birthday/5.png": 2561,
	"./birthday/6.png": 3831,
	"./birthday/7.png": 1216,
	"./club/1.png": 4975,
	"./club/2.png": 4315,
	"./club/3.png": 9186,
	"./club/4.png": 1557,
	"./club/5.png": 3424,
	"./club/6.png": 6551,
	"./club/7.png": 1161,
	"./club/8.png": 5199,
	"./club/9.png": 7175,
	"./festival/1.png": 875,
	"./festival/2.png": 6907,
	"./festival/3.png": 5895,
	"./festival/4.png": 4755,
	"./festival/5.png": 7265,
	"./festival/6.png": 4550,
	"./life/1.png": 2773,
	"./life/10.png": 5932,
	"./life/11.png": 5144,
	"./life/12.png": 8659,
	"./life/13.png": 7750,
	"./life/14.png": 7477,
	"./life/15.png": 3563,
	"./life/16.png": 8911,
	"./life/2.png": 7725,
	"./life/3.png": 3476,
	"./life/4.png": 2949,
	"./life/5.png": 9148,
	"./life/6.png": 4797,
	"./life/7.png": 5517,
	"./life/8.png": 8487,
	"./life/9.png": 7985,
	"./tourism/1.png": 3313,
	"./tourism/2.png": 8621,
	"./tourism/3.png": 8814,
	"./tourism/4.png": 5711,
	"./tourism/5.png": 8321,
	"./tourism/6.png": 2419,
	"./tourism/7.png": 7436,
	"./tourism/8.png": 6834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1245;